import type { AppState } from 'state/state.model';

export function hasGivenConsentToVideo(state: AppState): boolean | undefined {
  return state.userConsent?.hasGivenConsentToVideo;
}
